import DetailVM from './detail-vm';
import Vue from 'vue';

import 'libs/vue-extensions';

export default {
  init(element) {
    const vm = new Vue(DetailVM);

    vm.bindData(
      JSON.parse(element.dataset.courseworkJson),
      JSON.parse(element.dataset.userPreferencesJson)
    );

    vm.$mount(element);
  }
};
